import { Handle, Position } from '@xyflow/react';
import { useUnistyles } from 'react-native-unistyles';
import { Pressable, Text } from 'react-native';
import Unicon from '@/components/General/Unicon';
import { FONT, ADD_STEP_WIDTH } from '../constants';
import { TARGET_HANDLE_ID } from '../handles';

export default function AddStepNode({ data }) {
    const { theme } = useUnistyles();
    const { onAddStep, sourceStepID, branchID, branchLabel, canvasPosition, basePosition, readOnly } = data;

    return (
        <div style={{
            width: ADD_STEP_WIDTH,
            borderRadius: 10,
            overflow: 'hidden',
            fontFamily: FONT,
            position: 'relative',
        }}>
            <Handle
                type="target"
                position={Position.Top}
                id={TARGET_HANDLE_ID}
                isConnectable={false}
                style={{ opacity: 0, width: 1, height: 1, minWidth: 0, minHeight: 0, border: 'none', top: 0, pointerEvents: 'none' }}
            />
            {!readOnly && (
                <Pressable
                    onPress={() => onAddStep?.(sourceStepID, branchID, branchLabel, canvasPosition, basePosition)}
                    style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        backgroundColor: theme.colors.primaryContainer,
                        borderRadius: 8,
                        padding: 6,
                        gap: 4,
                    }}
                >
                    <Unicon name="add" size={14} colorVariant="primary" />
                    <Text style={{ fontSize: 12, color: theme.colors.primary }}>Add Step</Text>
                </Pressable>
            )}
        </div>
    );
}
